export const TIEMPO_LIMITE_MS = 15000;

export const esTimeout = (error) => error?.name === "AbortError";

const fetchConTimeout = async (url, options = {}, ms = TIEMPO_LIMITE_MS) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), ms);
  try {
    return await fetch(url, { ...options, signal: controller.signal });
  } finally {
    clearTimeout(timer);
  }
};

export default fetchConTimeout;
